import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import playIcon from 'images/icons/play_release_hover.png'
import TransparentCoverIcon from 'images/icons/transparent_cover.svg'
import { ImageWithFallback } from 'components'

import trStyles from './TableRow.module.scss'

@connect()
class TableRow extends React.PureComponent {
  static propTypes = {
    isIpadView: PropTypes.bool,
    isHighlighted: PropTypes.bool,
    controlledHover: PropTypes.bool,
    item: PropTypes.object.isRequired,
    columns: PropTypes.arrayOf(PropTypes.object),
    resizableWidths: PropTypes.object,
    key: PropTypes.string,
    onPlay: PropTypes.func,
    onClick: PropTypes.func,
    renderModal: PropTypes.func,
    selectedItem: PropTypes.object,
    setSelectedItem: PropTypes.func,
    tableId: PropTypes.string.isRequired,
    onHoverStop: PropTypes.func
  }

  handleMouseOver = (item) => {
    const { setSelectedItem } = this.props
    if (setSelectedItem) {
      setSelectedItem(item)
    }
  }

  handleMouseOut = () => {
    const { item, onHoverStop, setSelectedItem } = this.props
    if (setSelectedItem) {
      setSelectedItem(null)
    }

    if (typeof onHoverStop === 'function') {
      onHoverStop(item)
    }
  }

  renderTransparentCover = () => {
    const { item, onPlay, isIpadView } = this.props
    return (
      <div className="absolute top-0 left-0 w-full h-full">
        <img
          src={TransparentCoverIcon}
          className="absolute top-0 left-0 w-full h-full"
        />
        <button
          type="button"
          className="absolute top-0 left-0 w-full h-full focus:outline-none"
          onClick={(e) => {
            e.stopPropagation()
            if (isIpadView) {
              this.handleMouseOut()
            }
            onPlay(item)
          }}
        >
          <img src={playIcon} className="w-full h-full" alt="play button" />
        </button>
      </div>
    )
  }

  render() {
    const {
      item,
      key,
      onClick,
      resizableWidths,
      columns,
      renderModal,
      onPlay,
      isHighlighted,
      isIpadView,
      selectedItem,
      tableId,
      controlledHover = false
    } = this.props

    let hovered = false
    if (selectedItem) {
      hovered = selectedItem === item
    }

    const showModal = controlledHover || hovered

    const cells = columns.map((column, index) => {
      // const width = resizableWidths[column.field] || column.width;
      const width = column.width
      if (column.image) {
        return (
          <div
            key={`${item.label} logo ${index + 1}`}
            className={`relative flex-none w-10 h-10 mx-2 ${
              column.cellStyleName ? trStyles[column.cellStyleName] : ''
            } ${trStyles['table-row-image']}`}
          >
            <ImageWithFallback
              className={`w-full h-full shadow-button object-cover ${
                isHighlighted ? 'border-2 border-cerulean' : ''
              }`}
              src={item[column.src]}
              fallback={column.fallback}
              alt="album cover"
            />
            {onPlay && hovered && this.renderTransparentCover()}
          </div>
        )
      } else if (column.field) {
        return (
          <div
            key={`${column} ${index + 1}`}
            className={`text-left text-white font-header cursor-default ${
              column.cellClassName
            } ${column.desktopOnly ? 'xl:block hidden' : ''} ${column.cellStyleName ? trStyles[column.cellStyleName] : ''}`}
            style={{ width }}
          >
            {item[column.field]
              ? column.format
                ? column.format(item[column.field])
                : item[column.field]
              : ''}
          </div>
        )
      } else return ''
    })
    return (
      <div
        key={key}
        className={`relative ${hovered ? 'bg-mako' : 'bg-transparent'} ${tableId ? trStyles[tableId] || '' : ''}`}
        onClick={() => {
          if (isIpadView) {
            if (!hovered) {
              this.handleMouseOver(item)
            } else {
              this.handleMouseOut()
              if (onClick) {
                onClick(item)
              }
            }
          } else if (onClick) {
            onClick(item)
          }
        }}
      >
        <div
          className={`flex flex-row items-center justify-start cursor-pointer ${trStyles['table-row']}`}
          onMouseEnter={() => {
            this.handleMouseOver(item)
          }}
          onMouseLeave={this.handleMouseOut}
        >
          {cells}
          {
            <div className="mx-4 w-6 absolute right-0">
              {showModal && renderModal && renderModal(item, hovered)}
            </div>
          }
        </div>
      </div>
    )
  }
}
export default withTranslation()(TableRow)
